<template>
  <div class="d-flex flex-column flex-root">
    <div class="d-flex flex-column flex-lg-row flex-column-fluid justify-content-center bg-ubbi" style="background-color: #780f5a;">
      <div class="d-flex flex-column flex-center text-center p-10">
        <div class="card card-flush w-100 w-lg-800px py-5">
          <div class="card-body py-15 py-lg-20">
            <div v-if="isRejected">
              <img alt="Logo" :src="require('@/assets/images/undraw_medicine_b-1-ol.svg')" class="h-200px">
              <br><br><br>
              <h1>Seu convite para o local "{{infos.place_name}}" foi cancelado!</h1>
              <br><br><br>
              <a class="btn btn-primary" :href="siteUrl">
                Ir para o site
              </a>
            </div>
            <div v-else-if="isAccepted">
              <img alt="Logo" :src="require('@/assets/images/undraw_medicine_b-1-ol.svg')" class="h-200px">
              <br><br><br>
              <h1>Seu convite para o local "{{infos.place_name}}" foi aceito!</h1>
              <br><br><br>
              <router-link class="btn btn-primary" to="/">
                Acessar
              </router-link>
            </div>
            <div v-else-if="isInvalid">
              <img alt="Logo" :src="require('@/assets/images/thinking_face-cuate.svg')" class="h-200px">
              <br>
              <h1>{{ invalidMessage }}</h1>
              <br><br>
              <a class="btn btn-primary" :href="siteUrl">
                Ir para o site
              </a>
            </div>
            <div v-else>
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-13">
                    <router-link to="/" class="">
                      <img v-if="isAccept" alt="Logo" :src="require('@/assets/images/undraw_business_deal_re_up4u.svg')" class="h-150px">
                      <img v-else alt="Logo" :src="require('@/assets/images/undraw_cancel_re_pkdm.svg')" class="h-150px">
                    </router-link>
                  </div>
                </div>
              </div>
              <h1 class="fw-bolder text-gray-900 mb-7">Olá {{ infos.user_name || 'Usuário' }}</h1>

              <div class="fw-semibold fs-6 text-gray-500 mb-7">
                Você tem certeza que deseja {{labelAction}} o convite <br>
                para acessar o(a) {{infos.place_name}} na plataforma da Ubbimed?
              </div>

              <div v-if="isAccept" class="invite-form text-start">
                <div v-if="hasAccount">
                  <div v-if="existingAccountFound" class="alert alert-info" role="status">
                    Encontramos sua conta. Digite sua senha atual para aceitar o convite.
                  </div>
                  <div class="alert alert-danger" v-show="messageErrorLogin" role="alert">
                    {{ messageErrorLogin }}
                  </div>

                  <div class="fv-row mb-8">
                    <div class="w-100 d-inline-flex mb-3 px-2 py-3 fw-semibold text-muted bg-secondary bg-opacity-10 border border-secondary border-opacity-10 rounded-2">
                      <i class="bi bi-person-circle fa-1x me-2 mt-1"></i> {{ accountLabel }}
                    </div>

                    <label class="form-label fw-bolder text-dark fs-6">
                      Para continuar, digite sua senha atual <span class="text-danger">*</span>
                    </label>
                    <input class="form-control form-control-lg form-control-solid"
                           v-model="auth.password" required
                           type="password" name="password" autocomplete="off" placeholder="Digite sua senha">
                    <button type="button" class="link-primary fs-6 fw-bolder btn btn-link px-0"
                            data-bs-toggle="modal" data-bs-target="#ModalRecoverPassword">
                      Esqueceu a senha?
                    </button>
                  </div>
                </div>
                <div v-else>
                  <div class="alert alert-danger" v-show="messageErrorLogin" role="alert">
                    {{ messageErrorLogin }}
                  </div>

                  <div class="row g-4 mb-8">
                    <div class="col-12 col-md-6">
                      <label class="form-label fw-bolder text-dark fs-6">
                        Nome <span class="text-danger">*</span>
                      </label>
                      <input class="form-control form-control-lg form-control-solid"
                             v-model="auth.user_name" required type="text" name="user_name"
                             autocomplete="off" placeholder="Digite o seu nome">
                    </div>
                    <div class="col-12 col-md-6">
                      <label class="form-label fw-bolder text-dark fs-6">
                        E-mail <span class="text-danger">*</span>
                      </label>
                      <input class="form-control form-control-lg form-control-solid"
                             v-model="auth.user_email" required type="email" name="user_email"
                             @blur="checkExistingAccount().catch(error => messageErrorLogin = resolveError(error))"
                             :disabled="emailLocked"
                             autocomplete="off" placeholder="Digite o seu e-mail">
                    </div>
                    <div class="col-12 col-md-6">
                      <label class="form-label fw-bolder text-dark fs-6">
                        CPF <span class="text-danger">*</span>
                      </label>
                      <input class="form-control form-control-lg form-control-solid"
                             v-model="auth.user_cpf" required type="text" name="user_cpf"
                             v-mask="'###.###.###-##'"
                             autocomplete="off" placeholder="Digite o seu CPF">
                    </div>
                    <div class="col-12 col-md-6">
                      <label class="form-label fw-bolder text-dark fs-6">
                        Telefone <span class="text-danger">*</span>
                      </label>
                      <input class="form-control form-control-lg form-control-solid"
                             v-model="auth.user_phone" required type="text" name="user_phone"
                             v-mask="['(##) ####-####', '(##) #####-####']"
                             :disabled="phoneLocked"
                             autocomplete="off" placeholder="Digite o seu telefone">
                    </div>
                    <div class="col-12 col-md-6">
                      <label class="form-label fw-bolder text-dark fs-6">
                        Defina sua senha <span class="text-danger">*</span>
                      </label>
                      <input class="form-control form-control-lg form-control-solid"
                             v-model="auth.user_password" required type="password" name="password"
                             autocomplete="off" placeholder="Digite uma nova senha">
                    </div>
                    <div class="col-12 col-md-6">
                      <label class="form-label fw-bolder text-dark fs-6">
                        Confirme a senha <span class="text-danger">*</span>
                      </label>
                      <input class="form-control form-control-lg form-control-solid"
                             v-model="auth.user_password_confirmation" required type="password"
                             autocomplete="off" placeholder="Confirme a senha">
                    </div>
                  </div>
                </div>
              </div>

              <button class="btn" :class="isAccept ? 'btn-primary' : 'btn-danger'"
                      @click="handdlerSubmit" :disabled="isLoading">
                <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                Continuar e {{labelAction}} o convite
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>

  <RecoverPasswordModal/>
</template>

<script>
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import Config from "../../config";
import RecoverPasswordModal from "../auth/RecoverPasswordModal";
import {mask} from "vue-the-mask";

export default {
  name: "InviteUserAction",
  components: {
    RecoverPasswordModal,
  },
  directives: {mask},
  data() {
    return {
      isLoading: false,
      existingAccountFound: false,
      isInvalid: false,
      invalidMessage: '',
      messageErrorLogin: '',
      isRejected: false,
      isAccepted: false,
      infos: {},
      place: {},
      auth: {
        user_name: '',
        user_cpf: '',
        user_password: '',
        user_password_confirmation: '',
        user_email: '',
        user_phone: '',

        username: '',
        password: '',
      },
      siteUrl: Config.site_url_prof,
    }
  },
  mounted() {
    if (this.$store.getters['auth/isAuth'] && this.isAccept) {
      this.$store.dispatch("auth/logout");
    }
    this.findInfosToken();
  },
  computed: {
    inviteId() {
      return this.$route.params.inviteId;
    },
    inviteToken() {
      return this.$route.query.token;
    },
    action() {
      return this.$route.params.action;
    },
    placeId() {
      return this.$route.params.placeId;
    },
    isAccept() {
      return this.action === 'accept';
    },
    labelAction() {
      return this.isAccept ? 'aceitar' : 'recusar';
    },
    hasAccount() {
      return !!(this.infos.has_account || (this.infos.user_name && this.infos.user_password));
    },
    emailLocked() {
      return !!this.infos.user_email;
    },
    phoneLocked() {
      return this.infos.invite_channel === 'whatsapp' && !!this.infos.user_phone;
    },
    accountLabel() {
      return this.infos.user_email || this.infos.user_phone || this.infos.user_cpf || '';
    },
  },
  methods: {
    accept() {
      let params = {'token': this.inviteToken};
      return http.patch(`/places/${this.placeId}/invites/${this.inviteId}/accept`, params).then(() => {
        Alert.toastSuccess('Convite aceito com sucesso.');

        this.isAccepted = true;
        this.isRejected = false;
        this.isInvalid = false;
      });
    },
    login() {
      this.messageErrorLogin = null;
      return this.$store.dispatch('auth/login', { ...this.auth, deferPlaceLoading: true }).then(async () => {

        await this.accept();
      }).catch((error) => {
        this.messageErrorLogin = this.resolveError(error);
      });
    },
    async checkExistingAccount() {
      const email = this.auth.user_email.trim().toLowerCase();
      if (this.infos.invite_channel !== 'whatsapp' || this.hasAccount || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return false;

      const { data } = await http.get(`/places/${this.placeId}/invites/${this.inviteId}/infos`, {
        params: { token: this.inviteToken, email },
      });
      if (this.auth.user_email.trim().toLowerCase() !== email || !data.has_account) return false;

      this.infos.has_account = true;
      this.infos.user_email = email;
      this.auth.username = email;
      this.auth.password = '';
      this.auth.user_password = '';
      this.auth.user_password_confirmation = '';
      this.existingAccountFound = true;
      this.messageErrorLogin = '';
      return true;
    },
    async register() {
      try {
        if (await this.checkExistingAccount() || this.existingAccountFound) return;
      } catch (error) {
        this.messageErrorLogin = this.resolveError(error);
        return;
      }

      if (!this.validateNewAccount()) {
        return;
      }

      return http.post(`/employees/register`, {
        user_name: this.auth.user_name,
        user_cpf: this.auth.user_cpf,
        user_email: this.auth.user_email,
        user_password: this.auth.user_password,
        user_phone: this.auth.user_phone,
      }).then(async (response) => {
        this.$store.commit('auth/setUser', response.data.user);
        this.$store.commit('auth/setToken', response.data.token);
        this.infos.has_account = true;
        this.auth.username = this.auth.user_email;
        this.auth.password = this.auth.user_password;

        await this.accept();
      }).catch((error) => {
        this.messageErrorLogin = this.resolveError(error);
      });
    },
    reject() {
      let params = {'token': this.inviteToken};
      return http.patch(`/places/${this.placeId}/invites/${this.inviteId}/reject`, params).then(() => {
        Alert.toastSuccess('Convite recusado com sucesso.');

        this.isRejected = true;
        this.isAccepted = false;
        this.isInvalid = false;
      }).catch((e) => {
        Alert.toastError(e.response.data);
      });
    },
    findInfosToken() {
      let params = {params: {'token': this.inviteToken}};
      http.get(`/places/${this.placeId}/invites/${this.inviteId}/infos`, params).then((response) => {

        this.infos = response.data;
        this.auth.username = this.infos.user_email || this.infos.user_cpf || '';
        this.auth.user_email = this.infos.user_email || '';
        this.auth.user_phone = this.infos.user_phone || '';
        this.auth.user_name = this.infos.user_name || '';
        this.auth.user_cpf = this.infos.user_cpf || '';
        this.isRejected = false;
        this.isAccepted = false;
      }).catch((e) => {
        this.invalidMessage = this.resolveError(e);
        this.isInvalid = true;
      });
    },
    async handdlerSubmit() {
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        if (!this.isAccept) {
          return await this.reject();
        }

        if (this.hasAccount) {
          return await this.login();
        }

        return await this.register();
      } finally {
        this.isLoading = false;
      }
    },
    validateNewAccount() {
      this.messageErrorLogin = '';
      if (!this.auth.user_name || !this.auth.user_cpf || !this.auth.user_email || !this.auth.user_phone || !this.auth.user_password) {
        this.messageErrorLogin = 'Informe nome, CPF, e-mail, telefone e senha.';
        return false;
      }

      if (this.auth.user_password.length < 6) {
        this.messageErrorLogin = 'A senha deve ter no mínimo 6 caracteres.';
        return false;
      }

      if (this.auth.user_password !== this.auth.user_password_confirmation) {
        this.messageErrorLogin = 'As senhas devem ser iguais.';
        return false;
      }

      return true;
    },
    resolveError(error) {
      const data = error?.response?.data;
      const fieldError = data?.errors ? Object.values(data.errors).flat()[0] : null;
      return fieldError || data?.message || (typeof data === 'string' && data) || 'Não foi possível concluir a operação. Tente novamente.';
    },
  },
}
</script>

<style scoped>
.invite-form {
  text-align: left;
}

.invite-form .form-label {
  display: block;
  text-align: left;
  margin-bottom: 0.4rem;
}
</style>